/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Service, { inject as service } from '@ember/service';
import { type TaskGenerator } from 'ember-concurrency';
import { post } from 'embercom/lib/ajax';
import type Store from '@ember-data/store';
import { dropTask } from 'ember-concurrency-decorators';
import type Contract from 'embercom/models/billing/contract';

interface UpdateSubscriptionParams {
  plan_ids: Array<number>;
  core_seats: number | undefined;
  app_id: string;
  admin_id: string;
  copilot_seats: number | undefined;
}

export default class AnnualSubscriptionUpdateService extends Service {
  @service appService: any;
  @service customerService: any;
  @service declare modelDataCacheService: any;
  @service declare store: Store;

  @dropTask
  *update({
    planIds,
    coreSeats,
    copilotSeats,
  }: {
    planIds: Array<number>;
    coreSeats?: number;
    copilotSeats?: number;
  }): TaskGenerator<void> {
    let contract = yield this.store.findRecord('billing/contract', this.appService.app.id);
    yield post(
      '/ember/conversions/update_annual_subscription',
      this.params(contract, planIds, coreSeats, copilotSeats),
    );
  }

  private params(
    contract: Contract,
    planIds: number[],
    coreSeats: number | undefined,
    copilotSeats: number | undefined,
  ): UpdateSubscriptionParams {
    return {
      plan_ids: planIds,
      core_seats: coreSeats ?? contract.contractUsageLimits.core_seat_count,
      app_id: this.appService.app.id,
      admin_id: this.appService.app.currentAdmin.id,
      copilot_seats: copilotSeats ?? contract.contractUsageLimits.copilot_seat_count,
    };
  }

  @dropTask
  *cancelScheduledDowngrade(): TaskGenerator<void> {
    yield post('/ember/conversions/cancel_scheduled_downgrade', {
      app_id: this.appService.app.id,
      admin_id: this.appService.app.currentAdmin.id,
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    annualSubscriptionUpdateService: AnnualSubscriptionUpdateService;
    'annual-subscription-update-service': AnnualSubscriptionUpdateService;
  }
}
